import { useCallback, useState } from 'react';
import { stripeService } from 'services/api';
import { SessionFlow } from 'services/api/entities';

type UseStripeSessionParams = {
  isLoading: boolean;
  error: Error | null;
  createUserPortalSession: (data: {
    returnUrl: string;
    flowType?: SessionFlow;
    successUrl?: string;
    songId?: string;
    releaseId?: string;
    isDistributionUpsellFlow?: boolean;
  }) => void;
};

const useStripeSession = (): UseStripeSessionParams => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const createUserPortalSession = useCallback(
    (data: {
      returnUrl: string;
      flowType?: SessionFlow;
      successUrl?: string;
      songId?: string;
      releaseId?: string;
      isDistributionUpsellFlow?: boolean;
    }) => {
      setIsLoading(true);
      setError(null);
      stripeService
        .createSession(data)
        .then((response) => {
          window.location.href = response.url;
        })
        .catch((err: Error) => setError(err))
        .finally(() => setIsLoading(false));
    },
    []
  );

  return {
    isLoading,
    error,
    createUserPortalSession,
  };
};

export default useStripeSession;
